import dashboardIcon from "../asset/dashboardIcon.svg";
import quotationIcon from "../asset/quatationIcon.svg";
import InvoiceIcon from "../asset/InvoiceIcon.svg";
import projectIcon from "../asset/projectIcon.svg";
import expensesIcon from "../asset/expensesIcon.svg";
import settingIcon from "../asset/settingIcon.svg";
import logoutIcon from "../asset/logoutIcon.svg";
import addIcon from "../asset/AddIcon.svg";
import deleteIcon from "../asset/delectIcon.svg";
import editIcon from "../asset/editIcon.svg";
import downloadIcon from "../asset/downloadIcon.svg";
import duplicateIcon from "../asset/duplicateIcon.svg";
import logo from "../asset/2k_logo.png";
import logo1 from "../asset/rasi.jpeg";
import logo2 from "../asset/logo2.jpeg";
import footer from "../asset/footer.jpeg";
import footer1 from "../asset/footer1.jpeg";
import srilakshmi from "../asset/srilakshmi.jpeg";
import rasispace from "../asset/rasispace.jpeg";
import rasispaceheader from "../asset/rasispaceheader.jpeg";
import logo11 from "../asset/logo11.jpg";
import rasispacegreen from "../asset/rashi space solution.png";
import rasispacefooter from "../asset/RashiSpaceFooter.png"


const exportImage = {
  footer: footer,
  footer1: footer1,
  logo: logo,
  logo1: logo1,
  logo2: logo2,
  logo11: logo11,
  dashboardIcon: dashboardIcon,
  quotationIcon: quotationIcon,
  InvoiceIcon: InvoiceIcon,
  projectIcon: projectIcon,
  expensesIcon: expensesIcon,
  settingIcon: settingIcon,
  logoutIcon: logoutIcon,
  addIcon: addIcon,
  deleteIcon: deleteIcon,
  editIcon: editIcon,
  downloadIcon: downloadIcon,
  duplicateIcon: duplicateIcon,
  srilakshmi: srilakshmi,
  rasispace: rasispace,
  rasispaceheader: rasispaceheader,
  rasispacegreen: rasispacegreen,
  rasispacefooter: rasispacefooter,
};

export default exportImage;
